"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _FDSContract = _interopRequireDefault(require("./FDS-Contract"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.


var Tx =
/*#__PURE__*/
function () {
  function Tx(config, account) {
    _classCallCheck(this, Tx);

    this.account = account;
    this.config = config;
    this.web3 = this.config.web3;
  }

  _createClass(Tx, [{
    key: "getContract",
    value: function getContract(account, abi, address) {
      var c = new _FDSContract.default(this.config, account, abi);
      return c.at(address);
    }
  }, {
    key: "deployContract",
    value: function deployContract(account, abi, bytecode) {
      var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var gas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 15000000;
      var c = new _FDSContract.default(this.config, account, abi, bytecode); //predict

      return c.deploy(args, gas);
    }
  }, {
    key: "syncNonce",
    value: function syncNonce(account) {
      return this.web3.eth.getTransactionCount(account.wallet.address);
    }
    /**
     * 
     * @param {any} account to send from
     * @param {any} toAddress 0xfff
     * @param {any} amount in eth
     * @param {any} transactionCallback callback
     * @param {any} transactionSignedCallback callback
     * @returns {any} transaction
     */

  }, {
    key: "pay",
    value: function pay(account, toAddress, amount) {
      var _this = this;

      var gas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 15000000;
      var transactionCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console.log;
      var transactionSignedCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : console.log;
      return new Promise(function (resolve, reject) {
        var tx = {
          from: account.address,
          to: toAddress,
          gas: gas,
          gasPrice: _this.gasPrice,
          value: (0, _web3Utils.toWei)(amount, 'ether')
        };
        transactionCallback(tx);
        return _this.web3.eth.accounts.signTransaction(tx, account.privateKey).then(function (signed) {
          return _this.web3.eth.sendSignedTransaction(signed.rawTransaction).once('confirmation', function (i, hash) {
            resolve(hash);
          });
        });
      });
    }
    /**
     * Ensure address has enough balance
     * @getBalance
     * @param {string} address to check
     * @returns {void} balance of address 
     */

  }, {
    key: "getBalance",
    value: function getBalance(address) {
      try {
        return this.web3.eth.getBalance(address);
      } catch (error) {
        console.error("can't access gateway ", config.ethGateway);
      }
    }
  }]);

  return Tx;
}();

var _default = Tx;
exports.default = _default;
module.exports = exports.default;